import { observer } from 'mobx-react';
const ListComponent = observer(() => {
	return 'dashboard';
});

export default ListComponent;
